/* eslint-disable jsx-a11y/anchor-is-valid */
import {Column} from 'react-table'
import {useKTable} from '../../../../../../contexts/KTableProvider'
import {
  KTable,
  KTableHeader,
  KTableLoading,
  KTableSelectionCellNonMultiple,
} from '../../../../../../components/UI'
import {FC, useEffect, useMemo} from 'react'
import debounce from 'debounce'
import {TabCentralModel} from '../../../../../../models'
import {KTCard, KTSVG} from '../../../../../../../../_metronic/helpers'
import {useCentral} from '../../../../../../hooks/useCentral'
import {UserModel} from '../../../../model'
import {getUser} from '../../../../services'
import {useKhipu} from '../../../../../../hooks/useKhipu'
import {useTableMaster} from '../../../../hooks'
import useEnterpriseService, {
  ENTERPRISE_SEARCH_MIN_LENGTH,
  ENTERPRISE_SEARCH_DEBOUNCE_MS,
} from '../../../../hooks/useEnterpriseService'
import useCecoService from '../../../../hooks/useCecoService'
const TableUser: FC = () => {
  const {
    data,
    setData,
    setPagination,
    loading,
    setLoading,
    clearSelected,
    pagination,
    updateTable,
    setUpdateTable,
    selectedOn,
    clearTable,
    setClearTable,
  } = useKTable()
  const {currentTabItem, changeCurrentTabItem, isAllowed} = useCentral()
  const {searchValues, clearSearchValues} = useKhipu()
  const {statusUser, getStatusUserList, docType, getDocTypeList} = useTableMaster()
  const {getEnterpriseSearchOptions} = useEnterpriseService()
  const {ceco, getCECOList, handleClear} = useCecoService()

  const makeDebouncedEnterpriseLoader = () =>
    debounce((inputValue: string, callback: (options: any[]) => void) => {
      const search = (inputValue || '').trim()
      if (search.length < ENTERPRISE_SEARCH_MIN_LENGTH) {
        callback([])
        return
      }
      getEnterpriseSearchOptions(search).then(callback)
    }, ENTERPRISE_SEARCH_DEBOUNCE_MS)

  const loadEmpresaContratanteOptions = useMemo(makeDebouncedEnterpriseLoader, [])
  const loadEmpresaSubcontratistaOptions = useMemo(makeDebouncedEnterpriseLoader, [])

  useEffect(() => {
    return () => {
      loadEmpresaContratanteOptions.clear()
      loadEmpresaSubcontratistaOptions.clear()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const getUserList = async () => {
    try {
      setLoading(true)
      const {data: response} = await getUser(searchValues, pagination.currentPage)
      if (!response.error) {
        setData(response.data)
        setPagination({
          ...pagination,
          totalResults: response.total,
        })
      }
      setLoading(false)
    } catch (error) {
      setLoading(false)
    }
  }
  useEffect(() => {
    getDocTypeList()
    getStatusUserList()
    getCECOList()
    return () => {
      clearSearchValues()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    getUserList()
    if (currentTabItem.loadingTable) {
      clearSelected()
      getUserList()
      setClearTable(false)
      changeCurrentTabItem({...currentTabItem, loadingTable: false})
    }
  }, [pagination.currentPage, currentTabItem.loadingTable])
  useEffect(() => {
    if (updateTable) {
      if (pagination.currentPage === 1) {
        getUserList()
      } else {
        setPagination({
          ...pagination,
          currentPage: 1,
          perPage: 10,
          totalResults: 0,
        })
      }
      setUpdateTable(false)
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [updateTable])
  const handleViewPanel = (rowData: any) => {

    console.log('rowData', rowData)

    const getRow = rowData.row
    const getArrows = rowData.data
    const getData = getArrows[getRow.index]
    const obj: TabCentralModel = {
      ...currentTabItem,
      showPanel: true,
      content: {
        ...currentTabItem.content,
        detailPanel: 'tab-user',
      },
      idToEdit: getData.id,
      idToDelete: '',
      aditionalInformation: {
        ...currentTabItem.aditionalInformation,
        user: {
          applicationName: getData.aplicacion,
        },
      },
    }
    console.log('obj', obj)
    changeCurrentTabItem(obj)
    clearSelected()
  }

  const handleGetId = (id: any) => {
    let idChange = id === currentTabItem.idToDelete ? '' : id
    const obj: TabCentralModel = {
      ...currentTabItem,
      showPanel: false,
      idToDelete: idChange,
      idToEdit: '',
    }
    changeCurrentTabItem(obj)
  }

  const columns: Column<UserModel>[] = useMemo(
    () => [
      {
        Header: (props) => <KTableHeader tableProps={props} showSelect={false} />,
        id: 'selection',
        Cell: ({...props}) => (
          <KTableSelectionCellNonMultiple
            id={props.data[props.row.index].id}
            clickHandler={handleGetId}
          />
        ),
      },

      {
        Header: (props) => (
          <KTableHeader
            tableProps={props}
            title='Tipo de Doc. Id.'
            name='tipoDocumentoId'
            data={docType}
            selecteable
          />
        ),
        accessor: 'tipoDocumento',
      },
      {
        Header: (props) => (
          <KTableHeader
            tableProps={props}
            title='Número de Doc. Id.'
            name={'numeroDocumento'}
            searcheable
          />
        ),
        accessor: 'numeroDocumento',
      },
      {
        Header: (props) => (
          <KTableHeader tableProps={props} title='Nombres' name={'nombres'} searcheable />
        ),
        accessor: 'nombres',
      },
      {
        Header: (props) => (
          <KTableHeader tableProps={props} title='Apellidos' name={'apellidos'} searcheable />
        ),
        accessor: 'apellidos',
      },
      {
        Header: (props) => (
          <KTableHeader
            tableProps={props}
            title='Nombre de usuario'
            name={'nombreUsuario'}
            searcheable
          />
        ),
        accessor: 'nombreUsuario',
      },
      {
        Header: (props) => (
          <KTableHeader tableProps={props} title='Correo' name={'email'} searcheable />
        ),
        accessor: 'email',
      },
      {
        Header: (props) => (
          <KTableHeader
            tableProps={props}
            title='Estado'
            name='estado'
            data={statusUser}
            selecteable
          />
        ),
        accessor: 'estado',
      },
      {
        Header: (props) => (
          <KTableHeader
            tableProps={props}
            title='Empresa Contratante'
            name='empresaContratanteId'
            selectLabel='empresaContratanteLabel'
            selecteableAsync
            loadOptions={loadEmpresaContratanteOptions as any}
            placeholder='Buscar por nombre...'
          />
        ),
        accessor: 'empresaContratanteId',
      },
      {
        Header: (props) => (
          <KTableHeader
            tableProps={props}
            title='Empresa Subcontratista'
            name='empresaSubcontratistaId'
            selectLabel='empresaSubcontratistaLabel'
            selecteableAsync
            loadOptions={loadEmpresaSubcontratistaOptions as any}
            placeholder='Buscar por nombre...'
          />
        ),
        accessor: 'empresaSubcontratistaId',
      },
      {
        Header: (props) => (
          <KTableHeader
            tableProps={props}
            title='Ceco'
            name='centroCosto'
            data={ceco}
            selecteable
          />
        ),
        accessor: 'centroCosto',
      },
      {
        Header: (props) => <KTableHeader tableProps={props} title='Ver' />,
        id: 'actions',
        Cell: ({...props}) => (
          <>
            {isAllowed('EDITAR') && (
              <div
                className='d-flex justify-content-center flex-shrink-0'
                onClick={() => handleViewPanel(props)}
              >
                <span className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm'>
                  <KTSVG path='/media/icons/duotune/general/gen055.svg' className='svg-icon-3' />
                </span>
              </div>
            )}
          </>
        ),
      },
    ],
    [docType, statusUser, loadEmpresaContratanteOptions, loadEmpresaSubcontratistaOptions, selectedOn, ceco],
  )

  useEffect(() => {
    if (clearTable) {
      handleClear()
      setClearTable(false)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [clearTable])

  return (
    <>
      {isAllowed('LISTAR') && (
        <KTCard shadow className='w-100'>
          <KTable data={data} columns={columns} classNameProps='dataTablecentral' />
          {loading ? <KTableLoading title='Cargando...' /> : null}
        </KTCard>
      )}
    </>
  )
}

export {TableUser}
